import { Component, Input } from '@angular/core';

export interface TabItem {
  id: string;
  /** Clave de es.json; el layout la traduce. */
  labelKey: string;
  icon: string;
}

@Component({
  selector: 'app-tabs-layout',
  templateUrl: './tabs-layout.component.html',
  styleUrls: ['./tabs-layout.component.scss'],
  standalone: false
})
export class TabsLayoutComponent {
  @Input() tabs: TabItem[] = [];

  /** Stable identity so the tab buttons aren't recreated on each render. */
  trackByTabId(_index: number, tab: TabItem): string {
    return tab.id;
  }
}
